module.exports = __webpack_public_path__ + "static/media/file-doc.8af7b037.svg";